import {NameId} from '@drl/core/models';

export class PhrTags extends NameId {}
